import React, { Component } from 'react';
import { connect } from 'react-redux';

import { fetchCustomerAuthDetails } from 'actions/authentication';
import { fetchAccountInfo } from 'actions/account/account';
import { fetchShipmentTracking } from 'actions/account/shipmentTracking';
import { firePixelServer } from 'actions/pixelServer';
import MartyLink from 'components/common/MartyLink';
import BackNav from 'components/account/BackNav';
import Breadcrumb from 'components/account/Breadcrumb';
import { PageLoader } from 'components/Loader';
import SiteAwareMetadata from 'components/SiteAwareMetadata';
import ExpandedTrackingProgress from 'components/account/ShipmentTracking/ExpandedTrackingProgress';
import TrackingEvents from 'components/account/ShipmentTracking/TrackingEvents';
import css from 'styles/containers/account/shipmentTracking.scss';

export class ShipmentTracking extends Component {
  componentDidMount() {
    const {
      firePixelServer,
      shipmentTracking: { trackingInfo }
    } = this.props;

    if (!trackingInfo.length) {
      this.fetchData();
    }

    firePixelServer('shipment-tracking');
  }

  fetchData() {
    const {
      fetchAccountInfo,
      fetchCustomerAuthDetails,
      fetchShipmentTracking,
      params: { orderId, shipmentId }
    } = this.props;

    fetchCustomerAuthDetails()
      .then(({ success }) => {
        success && fetchAccountInfo();
      });

    fetchShipmentTracking(orderId, shipmentId);
  }

  makeErrorMessage() {
    const {
      account,
      params: { orderId },
      shipmentTracking: { hasFetchError }
    } = this.props;

    const customerEmail = account.customerInfo?.email;

    if (hasFetchError) {
      return (
        <div className={css.trackingError}>
          <h4>Unable to find order</h4>
          <p>We're sorry, we could not find order <strong>{orderId}</strong>{ customerEmail && <> in account <strong>{customerEmail}</strong></> }.</p>
          <p>If you have more than one account, please ensure you are logged in to the correct account for this order.</p>
        </div>
      );
    }
    return <div className={css.trackingError}>We're sorry! Tracking information for this shipment is not currently available.</div>;
  }

  render() {
    const { shipmentTracking: { isLoading, trackingInfo }, params: { orderId } } = this.props;

    if (isLoading || !trackingInfo.length) {
      return <PageLoader centered={true}/>;
    }

    const shipmentTrackingItem = trackingInfo[0]; // on shipment page, only 1 tracking item is returned
    const { tracking: { events } } = shipmentTrackingItem;
    const items = [
      { name: `Order #${orderId}`, url: `/orders/${orderId}` },
      { name: 'Shipment Tracking' }
    ];

    return (
      <SiteAwareMetadata>
        <div className={css.shipmentTracking}>
          <Breadcrumb items={items}/>
          <div className={css.header}>
            <BackNav to={`/orders/${orderId}`}>Order #{orderId}</BackNav>
            <h1>Shipment Tracking</h1>
            <MartyLink to={`/orders/${orderId}`} className={css.orderId}>Order #{orderId}</MartyLink>
          </div>
          <hr className={css.divider}/>
          {
            events.length ? (
                <>
                  <ExpandedTrackingProgress trackingInfo={shipmentTrackingItem}/>
                  <hr className={css.divider}/>
                  <TrackingEvents events={events}/>
                </>
            ) : this.makeErrorMessage()
          }
        </div>
      </SiteAwareMetadata>
    );
  }
}

const mapStateToProps = state => ({
  account: state.account,
  authentication: state.authentication,
  shipmentTracking: state.shipmentTracking
});

export default connect(mapStateToProps, {
  fetchCustomerAuthDetails,
  fetchAccountInfo,
  fetchShipmentTracking,
  firePixelServer
})(ShipmentTracking);
